import { extractSheetData, resolveTemplate } from '@mythictable/sheets';

type CharacterLike = Record<string, unknown>;

/**
 * The name a token's sheet says it has, or '' when it has none.
 *
 * Takes the character behind the token (see `tokenCharacter`), not the token —
 * a token no longer carries sheet data of its own.
 *
 * WARNING: there is deliberately no `_name` fallback. `_name` is a library slug
 * with a file extension ("big-wolf.chr"), not a display name, and a template is
 * free to declare no token name at all — an unnamed token stays unnamed.
 */
export function tokenLabel(character: CharacterLike | null | undefined): string {
    if (!character) return '';

    const template = resolveTemplate(character);
    const field = template?.token?.name?.field;
    if (!field) return '';

    const value = extractSheetData(character, template)?.[field];
    return typeof value === 'string' ? value : '';
}
